// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useMemo} from 'react';
import {all_plans, plans_config} from 'hola_opt';

interface i_plans_for_ui {
    [plan_type: string]: { // isp/shared_dc/dedicated_dc and etc
        [period: string]: {
            limit: number,
            period: string,
            type: string,
            plan: {
                [key: string]: any;
                id: string;
                price: number;
                short_name: string;
                name: string;
                type: string;
                fallback_plan?: string; // id
            }
        }[]
    }
}
export const use_plans = ()=>{
    const plans = useMemo(()=>{
        const by_obj = {} as i_plans_for_ui;
        const plan_ids = Object.keys(plans_config || {});
        plan_ids.forEach(id=>{
            const conf = plans_config[id];
            if (conf.for_ui===false)
                return;
            if (!by_obj[conf.type])
                by_obj[conf.type] = {};
            const plan = all_plans.find(p=>p.id==id);
            if (!plan)
                return;
            if (!by_obj[conf.type][conf.period])
                by_obj[conf.type][conf.period] = [];
            by_obj[conf.type][conf.period].push({
                ...conf,
                plan,
            });
        });
        return by_obj;
    }, []);
    return {plans};
};
